import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class UserRoles {
  private oauthService = inject(OAuthService);

  parseJwt(token: string): unknown {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  hasRole(resource: string, role: string): boolean {
    const accessToken = this.oauthService.getAccessToken();
    if (!accessToken) {
      return false;
    }

    const decodedToken = this.parseJwt(accessToken) as {
      resource_access?: Record<string, { roles?: string[] }>;
    };
    return decodedToken.resource_access?.[resource]?.roles?.includes(role) || false;
  }
}
